export default __webpack_public_path__ + "static/media/hm-bold.b0e47d02.woff";